export default "__VITE_ASSET__C5uFd8zk__"